export default "__VITE_ASSET__CGYYlFmo__"